module.exports = __webpack_public_path__ + "img/icon_t6_c.4807f10a.png";